import { render, staticRenderFns } from "./KpiCardsAccounts.vue?vue&type=template&id=bececb52&lang=pug&"
import script from "./KpiCardsAccounts.vue?vue&type=script&lang=js&"
export * from "./KpiCardsAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports